import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ArtikelBild } from '../../store/models/artikelbild';

@Component({
    selector: 'kkis-app-artikelbild-thumbs1',
    templateUrl: './artikelbild-thumbs1.component.html',
    styleUrls: ['./artikelbild-thumbs1.component.scss']
})
export class ArtikelbildThumbs1Component implements OnInit {

    @Input()
    artikelBilder: ArtikelBild.IArtikelBilderDto;

    @Input()
    isVertical: boolean = true;

    @Output()
    selectedImage: EventEmitter<ArtikelBild.IArtikelBildDto> = new EventEmitter<ArtikelBild.IArtikelBildDto>();


    // Settings
    public config: PerfectScrollbarConfigInterface = {};


    constructor() { }

    ngOnInit(): void {
    }

    onSelectImage(artikelBild) {
        this.selectedImage.emit(artikelBild);
    }
}
